import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  SET_USER,
  CLEAR_USER,
  TOKEN_EXPIRED,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  VERIFY_RESET_TOKEN_REQUEST,
  VERIFY_RESET_TOKEN_SUCCESS,
  VERIFY_RESET_TOKEN_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  CLEAR_FORGOT_PASSWORD_STATE
} from '../constants/authConstants';

export const loginRequest = () => ({
  type: LOGIN_REQUEST
});

export const loginSuccess = (user, token) => ({
  type: LOGIN_SUCCESS,
  payload: { user, token }
});

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error
});

export const logoutRequest = () => ({
  type: LOGOUT_REQUEST
});

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS
});

export const setUser = (user) => ({
  type: SET_USER,
  payload: user
});

export const clearUser = () => ({
  type: CLEAR_USER
});

export const tokenExpired = () => ({
  type: TOKEN_EXPIRED
});

export const loginUser = (credentials) => ({
  type: 'LOGIN_SAGA',
  payload: credentials
});

export const logoutUser = () => ({
  type: 'LOGOUT_SAGA'
});

// Forgot Password Actions
export const forgotPasswordRequest = () => ({
  type: FORGOT_PASSWORD_REQUEST
});

export const forgotPasswordSuccess = (message) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: message
});

export const forgotPasswordFailure = (error) => ({
  type: FORGOT_PASSWORD_FAILURE,
  payload: error
});

export const verifyResetTokenRequest = () => ({
  type: VERIFY_RESET_TOKEN_REQUEST
});

export const verifyResetTokenSuccess = () => ({
  type: VERIFY_RESET_TOKEN_SUCCESS
});

export const verifyResetTokenFailure = (error) => ({
  type: VERIFY_RESET_TOKEN_FAILURE,
  payload: error
});

export const resetPasswordRequest = () => ({
  type: RESET_PASSWORD_REQUEST
});

export const resetPasswordSuccess = (message) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: message
});

export const resetPasswordFailure = (error) => ({
  type: RESET_PASSWORD_FAILURE,
  payload: error
});

export const clearForgotPasswordState = () => ({
  type: CLEAR_FORGOT_PASSWORD_STATE
});

// Saga Actions
export const forgotPassword = (email) => ({
  type: 'FORGOT_PASSWORD_SAGA',
  payload: email
});

export const verifyResetToken = (resetToken, email) => ({
  type: 'VERIFY_RESET_TOKEN_SAGA',
  payload: { resetToken, email }
});

export const resetPassword = (resetToken, email, newPassword) => ({
  type: 'RESET_PASSWORD_SAGA',
  payload: { resetToken, email, newPassword }
});